"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationList = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const store_1 = require("../store");
const mailboxActions_1 = require("../store/mailboxActions");
const ConversationListEntry_1 = require("./ConversationListEntry");
const renderItem = ({ item }, onPress) => {
    return react_1.default.createElement(ConversationListEntry_1.ConversationListEntry, { conversation: item, onPress: onPress });
};
const ConversationList = ({ initialConversationId, loadConversation: loadConversationProp, loadConversations: loadConversationsProp, ownProfileGid, setConversationId: setExternalConversationId, }) => {
    const dispatch = react_redux_1.useDispatch();
    const conversations = store_1.useConversations();
    const meta = store_1.useConversationsMeta();
    const isLoading = store_1.useConversationsAreLoading();
    const currentConversationId = store_1.useCurrentConversationId();
    const hasInitiallyLoaded = store_1.useHasInitiallyLoaded();
    const loadConversation = react_1.useCallback((conversationId) => {
        // Errors are (should be) handled and logged in the api of the client already
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadConversationProp(conversationId).then((conversation) => {
            if (conversation) {
                dispatch(mailboxActions_1.addConversation({ conversation }));
            }
        });
    }, [dispatch, loadConversationProp]);
    const loadConversations = react_1.useCallback((page) => {
        // Errors are (should be) handled and logged in the api of the client already
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadConversationsProp(page, 20).then((conversationsPayload) => {
            if (conversationsPayload) {
                dispatch(mailboxActions_1.addConversations(conversationsPayload));
            }
        });
    }, [dispatch, loadConversationsProp]);
    const onEntryPress = react_1.useCallback((conversationId) => {
        dispatch(mailboxActions_1.setCurrentConversationId({ conversationId }));
        setExternalConversationId === null || setExternalConversationId === void 0 ? void 0 : setExternalConversationId(conversationId);
    }, [dispatch, setExternalConversationId]);
    const onEndReached = react_1.useCallback(() => {
        if (isLoading || !meta || meta.lastPage)
            return;
        loadConversations(meta.currentPage + 1);
    }, [isLoading, loadConversations, meta]);
    react_1.useEffect(() => {
        dispatch(mailboxActions_1.setOwnProfileGid({ ownProfileGid }));
    }, [dispatch, ownProfileGid]);
    react_1.useEffect(() => {
        dispatch(mailboxActions_1.setCurrentConversationId({ conversationId: initialConversationId }));
    }, [dispatch, initialConversationId]);
    react_1.useEffect(() => {
        loadConversations(1);
    }, [loadConversations]);
    react_1.useEffect(() => {
        if (currentConversationId &&
            hasInitiallyLoaded &&
            !conversations.find((c) => c.id === currentConversationId)) {
            loadConversation(currentConversationId);
        }
    }, [
        conversations,
        currentConversationId,
        hasInitiallyLoaded,
        loadConversation,
    ]);
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(react_native_1.FlatList, { data: conversations, renderItem: (item) => renderItem(item, onEntryPress), keyExtractor: (listItem) => listItem.id, style: styles.list, scrollEnabled: true, onEndReached: onEndReached })));
};
exports.ConversationList = ConversationList;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        maxHeight: 786,
        overflow: 'hidden',
    },
    list: {
        flex: 1,
    },
});
